jQuery(document).ready(function() {
	var jQ = jQuery;
	var selectors = {
		TOTAL_ITEMS: '.cart-total-items .items-count',
		TOTAL_PRICE: '',
		SUBMIT_ADD_TO_CART: 'input[type=image], input.submit-add-to-cart',
		FORM_ADD_TO_CART: 'form[action*="/cart/add"]',
		FORM_UPDATE_CART: 'form[name=cartform]',
		FORM_UPDATE_CART_BUTTON: 'form[name=cartform] input[name=update]',
		FORM_UPDATE_CART_BUTTONS: 'input[type=image], input.button-update-cart',
		LINE_ITEM_ROW: '.cart-line-item',
		LINE_ITEM_QUANTITY_PREFIX: 'input#updates_',
		LINE_ITEM_PRICE_PREFIX: '.cart-line-item-price-',
		LINE_ITEM_REMOVE: '.remove a',
		EMPTY_CART_MESSAGE: '#empty'
	};
	var text = {
		ITEM: 'Item',
		ITEMS: 'Items'
	};
	var formatMoney = function(price) {
			return Shopify.formatMoney(price, '${{ amount }}');

		};
	$('#testhook').on('click', function() {
		console.log('test hook');
	});
	function add_to_cart_supermarche_and_ajax(target) {
		var minLength = 1; // Minimum length
		var quantityId = $(target).find(".quantity");
		if(quantityId.val() < minLength){
		console.log("nope");
		quantityId.val(1);
		alert("Quantity must be greater than or equal to 1");
		}
		else {
		console.log('e.target: ', target);
		jQ(target).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', true).addClass('disabled');
		Shopify.addItemFromForm(target);
		var submitButton = $(target).find(".submit-add-to-cart");
		console.log('submitButton: ', submitButton);
		addToCart(submitButton);
		}
	}
	jQ(selectors.FORM_ADD_TO_CART).submit(function(e) {
		e.preventDefault();
		add_to_cart_supermarche_and_ajax(e.target);
	});
	jQ(selectors.FORM_UPDATE_CART_BUTTON).click(function(e) {
		e.preventDefault();
		jQ(e.target.form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', true).addClass('disabled');
		Shopify.updateCartFromForm(e.target.form);
	});
	jQ(selectors.FORM_UPDATE_CART).delegate(selectors.LINE_ITEM_REMOVE, 'click', function(e) {
		e.preventDefault();
		var vid = this.href.split('/').pop().split('?').shift();
		Shopify.removeItem(vid);
		jQ(this).parents(selectors.LINE_ITEM_ROW).remove();
	});
	Shopify.onItemAdded = function(line_item, form) {
		jQ(form).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', false).removeClass('disabled');
		Shopify.getCart();
		setTimeout(function() {
			$('.nav-cart').addClass('pulsate')
		}, 2200);
		setTimeout(function() {
			$('.nav-cart').removeClass('pulsate');
		}, 2500);
	};
	$("#wishl-wrapper").on("submit", "form[action*='/cart/add']", function(e) {
		e.preventDefault();
		console.log('button clicked from favorites page');
		var target = $(e.target).closest('form');
		console.log('target: ', target);
		add_to_cart_supermarche_and_ajax(target);
	});
	
	Shopify.onCartUpdate = function(cart, form) {
		var message = '<span class="cart-total-items">' + cart.item_count + ' </span>';
		jQ(selectors.TOTAL_ITEMS).html(message);
		var price = formatMoney(cart.total_price);
		jQ(selectors.TOTAL_PRICE).html(price);
		if ((jQ(selectors.EMPTY_CART_MESSAGE).length > 0) && cart.item_count == 0) {
			jQ(selectors.FORM_UPDATE_CART).hide();
			jQ(selectors.EMPTY_CART_MESSAGE).show();
		}
		form = form || false;
		if (form) {
			if (cart.item_count > 0) {
				jQ.each(cart.items, function(index, cartItem) {
					jQ(selectors.LINE_ITEM_PRICE_PREFIX + cartItem.id).html(formatMoney(cartItem.line_price));
					jQ(selectors.LINE_ITEM_QUANTITY_PREFIX + cartItem.id).val(cartItem.quantity);
				});
				jQ(form).find('input[value=0]').parents(selectors.LINE_ITEM_ROW).remove();
				jQ(form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', false).removeClass('disabled');
			}
		}
	};
	Shopify.onError = function(XMLHttpRequest, textStatus) {};
});

 $('.grid-product-image-holder').click(function () {
	 var imagePosition = $(this).closest('.item').attr("data-position");
	 $(this).closest(".item").addClass("imageFadeInOut"); 
	 $(this).toggleClass("large-image");
	 $(this).closest(".item").toggleClass("large-item");
	 setTimeout(function() {
	 	$('html, body').animate({scrollTop: $('.' + imagePosition).offset().top - 70}, 300);
	 }, 450);
	 setTimeout(function() {
		  $(".item").removeClass("imageFadeInOut");
	  }, 1000);
   });
   
	/////////////////////////////////// WEIGHT PREFERENCES
	$(document).ready(function(){
		if (Cookies("weightpref") == null) {
		Cookies('weightpref', 'lb', {path: '/', domain: 'supermarchepa.com', expires: 365});
		}
		else if (Cookies("weightpref") == "kg"){
		  $( '.grid-pref-holder .kg' ).addClass('current-weight');
		  $( '.grid-pref-holder .lbs' ).removeClass('current-weight');
			};
	 });
		
		$(".grid-pref-holder .kg").on("click", function(e) {
		e.preventDefault();
		 $( '.kg .lbs' ).toggleClass('current-weight');
		 Cookies('weightpref', 'kg', {path: '/',	domain: 'supermarchepa.com',expires: 365});
		 location.reload();
		});
		
		$(".grid-pref-holder .lbs").on("click", function(e) {
		e.preventDefault();
		$( '.kg .lbs' ).toggleClass('current-weight');
		Cookies('weightpref', 'lb', {path: '/',	domain: 'supermarchepa.com',expires: 365});
		location.reload();
		});
		
		
//  FILTER MENU
// Open Filter
$('.grid-filter-holder').on('click', function (e) {
    if ($(this).hasClass('filter-active')) return;
    
    // Check for browser support
    if (!document.startViewTransition) {
        $(this).addClass('filter-active');
        $(".grid-pref-holder").addClass('grid-pref-holder-hide');
    } else {
        document.startViewTransition(() => {
            $(this).addClass('filter-active');
            $(".grid-pref-holder").addClass('grid-pref-holder-hide');
        });
    }
});

// Close Filter
$('.grid-filter-close').on('click', function (e) { 
    e.preventDefault();
    e.stopPropagation();

    const closeAction = () => {
        $('.grid-filter-holder').removeClass('filter-active');
        $(".grid-pref-holder").removeClass('grid-pref-holder-hide');
    };

    if (!document.startViewTransition) {
        closeAction();
    } else {
        document.startViewTransition(() => closeAction());
    }
});

// Ensure links don't trigger the "Open" logic
$(".grid-filter-holder a").on('click', function(e) {
    e.stopPropagation(); 
});

$('#careers .grid-filter-holder a, #carrieres .grid-filter-holder a').on('click', function (e) {
    // We don't preventDefault here because we want the link to function,
    // but we wrap the UI change in a transition.
    
    const closeFilter = () => {
        $('.grid-filter-holder').removeClass('filter-active');
        // If you are hiding the preference holder when the filter is active, 
        // bring it back now.
        $(".grid-pref-holder").removeClass('grid-pref-holder-hide');
    };

    if (!document.startViewTransition) {
        closeFilter();
    } else {
        document.startViewTransition(() => closeFilter());
    }
});
	
	// ALL DEPARTMENTS MENU
	$('.search-btn-wrapper').click(function () {
		event.preventDefault();
		$(".top-blur-overlay").addClass("top-blur-overlay-active");
		$('.all-depts-holder-list-mobile').addClass('all-depts-holder-list-mobile-hide');
		$(".nav-wrapper").addClass('nav-wrapper-hidden search-live');
		$(".mobile-search.search-btn-wrapper").addClass('mobile-search-hidden');
		$('#top-nav, #logo, .checkout').addClass('all-depts-holder-hide');
		setTimeout(function() {
		$(".all-depts-dropdown").addClass('all-depts-active');
		}, 100);
		setTimeout(function() {
		$("#search-field").focus();
		}, 200);
	  });
	  
	$('.all-depts-close').click(function (e) { 
			$('.all-depts-dropdown').removeClass('all-depts-active');
			setTimeout(function() {
			$(".top-blur-overlay").removeClass("top-blur-overlay-active");
			$(".nav-wrapper").removeClass('nav-wrapper-hidden search-live');
			$(".mobile-search.search-btn-wrapper").removeClass('mobile-search-hidden');
			$('#top-nav, #logo, .checkout').removeClass('all-depts-holder-hide');
			$('.all-depts-holder-list-mobile').removeClass('all-depts-holder-list-mobile-hide');
			}, 100);
			e.stopPropagation();
	});
	
$(document).keyup(function(e) {
    if (e.key === "Escape" || e.which == 27) {
        
        // Define the state changes
        const closeAllUI = () => {
            // Dropdowns & Holders
            $('.all-depts-dropdown').removeClass('all-depts-active');
            $('.grid-filter-holder').removeClass('filter-active');
            $('.mobile-nav-wrapper').removeClass('mobile-nav-active');
            
            // Layout Visibility
            $(".nav-wrapper").removeClass('nav-wrapper-hidden search-live');
            $(".mobile-search.search-btn-wrapper").removeClass('mobile-search-hidden');
            $('#top-nav, #logo, .checkout').removeClass('all-depts-holder-hide');
            
            // Modals & Overlays
            $(".modal-blur").addClass('modal-blur-hide');
            $(".modal-alert").addClass('modal-hide');
            
            // These were inside your timeout; for View Transitions, 
            // it's usually smoother to trigger them all at once.
            $(".top-blur-overlay").removeClass("top-blur-overlay-active");
            $('.all-depts-holder-list-mobile').removeClass('all-depts-holder-list-mobile-hide');
        };

        // Execute with View Transition support
        if (!document.startViewTransition) {
            closeAllUI();
        } else {
            document.startViewTransition(() => closeAllUI());
        }
    }
});

$(document).ready(function(){
	var ctrlPressed = false; //Variable to check if the the first button is pressed at this exact moment
	$(document).keydown(function(e) {
	  if (e.ctrlKey || e.which == 91 || e.which == 93 || e.which == 224) { //If it's control key
		ctrlPressed = true; //Set variable to true
	  }
	}).keyup(function(e) { //If user releases ctrl button
	  if (e.ctrlKey || e.which == 91 || e.which == 93 || e.which == 224) {
		ctrlPressed = false; //Set it to false
	  }
	}); //This way you know if ctrl key is pressed. You can change e.ctrlKey to any other key code you want
	
	$(document).keydown(function(e) { //For any other keypress event
	  if (e.which == 75) { //Checking if it's space button
		if(ctrlPressed == true){ //If it's space, check if ctrl key is also pressed
		 $(".top-blur-overlay").addClass("top-blur-overlay-active");
		 $('.all-depts-holder-list-mobile').addClass('all-depts-holder-list-mobile-hide');
		 $(".nav-wrapper").addClass('nav-wrapper-hidden');
		 $(".mobile-search.search-btn-wrapper").addClass('mobile-search-hidden');
		 $('#top-nav, #logo, .checkout').addClass('all-depts-holder-hide');
		 $(".modal-blur").addClass('modal-blur-hide');
		$(".modal-alert").addClass('modal-hide');
		$(".nav-wrapper").addClass('search-live');
		 setTimeout(function() {
		 $('.all-depts-holder').removeClass('all-depts-animation-reverse');
		 $(".all-depts-dropdown").addClass('all-depts-active');
		 }, 100);
		 setTimeout(function() {
		 $("#search-field").focus();
		 }, 200);
		  ctrlPressed = false; //Important! Set ctrlPressed variable to false. Otherwise the code will work everytime you press the space button again
		}
	  }
	})
	
	});
	
	$(".wk-button").click(function(){
		if (GlobalLang == "FR") {
			var addMessage = "AJOUTER À VOS FAVORIS";
			var removeMessage = "RETIRÉ DE VOS FAVORIS";
		}
			else {
			var addMessage = "ADDED TO FAVOURITES";
			var removeMessage = "REMOVED FROM FAVOURITES";
			};
		var itemID = $(this).closest(".item").find("#add-to-cart-animation-wrapper").attr("data-product-id");
		if ($(this).closest(".item").find(".wk-selected")[0]){
			$(".item-" + itemID).find('.notifier-favourite .notifier-message').html(removeMessage);
			$(".item-" + itemID).find('.notifier-favourite .notifier-message').addClass('message-red');
			$(".item-" + itemID).find('.notifier-favourite .favourite-heart').addClass('checkmark-remove');
		} else {
			$(".item-" + itemID).find('.notifier-favourite .notifier-message').html(addMessage);
			$(".item-" + itemID).find('.notifier-favourite .notifier-message').removeClass('message-red');
			$(".item-" + itemID).find('.notifier-favourite .favourite-heart').addClass('checkmark-show');
			$(".item-" + itemID).find('.notifier-favourite .favourite-heart').removeClass('checkmark-remove');
		}
		$(".item-" + itemID).find('.notifier-favourite').addClass('notifier-show');
		
		setTimeout(function() {$(".item-" + itemID).find('.notifier-favourite').removeClass('notifier-show');}, 1600);
		setTimeout(function() {$(".item-" + itemID).find('.notifier-favourite .favourite-heart').removeClass('checkmark-show');}, 1800);
	});
	

	//  MOBILE NAVIGATION
	$('.menu-btn').click(function () {
		event.preventDefault();
		$('.mobile-nav-wrapper').addClass('mobile-nav-active');
		$(".nav-wrapper").addClass('nav-wrapper-hidden');
    });
  
  	$('.mobile-nav-close').click(function (e) { 
		event.preventDefault();
		$('.mobile-nav-wrapper').addClass('mobile-nav-return-transition');
		$(".nav-wrapper").removeClass('nav-wrapper-hidden');
		
		setTimeout(function() {
			$('.mobile-nav-wrapper').removeClass('mobile-nav-active');
			$('.mobile-nav-wrapper').removeClass('mobile-nav-return-transition');
		}, 400);
		e.stopPropagation();
	});

	$(".mobile-nav-wrapper a").click(function(e) {
  	e.stopPropagation(); // allow navigation
});

<!-- SCROLL FUNCTION -->
document.addEventListener("DOMContentLoaded", function () {
  const scrollWrapper = document.querySelector(".scroll-wrapper");
  const item = document.querySelector(".scroll-wrapper .item"); // first item to measure width
  const btnLeft = document.getElementById("scroll-left");
  const btnRight = document.getElementById("scroll-right");

  if (!scrollWrapper || !item || !btnLeft || !btnRight) return;

  const itemWidth = item.offsetWidth;

  // Scroll buttons
  btnRight.addEventListener("click", () => {
	scrollWrapper.scrollBy({ left: itemWidth, behavior: "smooth" });
  });

  btnLeft.addEventListener("click", () => {
	scrollWrapper.scrollBy({ left: -itemWidth, behavior: "smooth" });
  });

  // Function to update arrow states
  function updateArrows() {
	const maxScrollLeft = scrollWrapper.scrollWidth - scrollWrapper.clientWidth;

	if (scrollWrapper.scrollLeft <= 0) {
	  btnLeft.classList.add("disabled");
	} else {
	  btnLeft.classList.remove("disabled");
	}

	if (scrollWrapper.scrollLeft >= maxScrollLeft - 1) { // -1 for rounding errors
	  btnRight.classList.add("disabled");
	} else {
	  btnRight.classList.remove("disabled");
	}
  }

  // Update on scroll
  scrollWrapper.addEventListener("scroll", updateArrows);

  // Initial state
  updateArrows();
});

// RECIPE REPLAY BUTTON
const recipeVid = document.getElementById('recipe-background-video');
const progressBar = document.getElementById('video-progress-bar');

function updateSmoothProgress() {
	if (recipeVid && !recipeVid.paused && !recipeVid.ended) {
		const percentage = (recipeVid.currentTime / recipeVid.duration) * 100;
		progressBar.style.width = percentage + '%';
	}
	// Keeps the loop running at the browser's refresh rate (60fps+)
	requestAnimationFrame(updateSmoothProgress);
}

// Start the loop
requestAnimationFrame(updateSmoothProgress);

// Reset logic remains the same
function replayVideo() {
	if (recipeVid) {
		recipeVid.currentTime = 0;
		recipeVid.play();
	}
}

//Compare Price Toggle
$(document).ready(function() {
  $('#unitPriceToggle').on('click', function() {
	var isOff = $(this).attr('data-state') === 'off';
	
	if (isOff) {
	  $(this).attr('data-state', 'on');
	  $('body').addClass('show-unit-prices');
	  localStorage.setItem('unitPriceView', 'on'); // Remember user preference
	} else {
	  $(this).attr('data-state', 'off');
	  $('body').removeClass('show-unit-prices');
	  localStorage.setItem('unitPriceView', 'off');
	}
  });

  // Check if the user turned it on previously
  if (localStorage.getItem('unitPriceView') === 'on') {
	$('#unitPriceToggle').attr('data-state', 'on');
	$('body').addClass('show-unit-prices');
  }
});